import React, { forwardRef, useImperativeHandle } from 'react';
import { string } from 'prop-types';

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

/**
 * reCAPTCHA Enterprise v3 — invisible, score-based.
 *
 * Exposes a single method via ref:
 *   const token = await captchaRef.current.execute(action);
 *
 * The Enterprise script is loaded by LandingPage via react-helmet-async.
 * This component just provides the imperative execute() interface.
 */
const Captcha = forwardRef((_props, ref) => {
  useImperativeHandle(ref, () => ({
    execute: (action = 'submit') => {
      return new Promise((resolve, reject) => {
        if (!window.grecaptcha?.enterprise) {
          reject(new Error('reCAPTCHA Enterprise not loaded'));
          return;
        }
        window.grecaptcha.enterprise.ready(async () => {
          try {
            const token = await window.grecaptcha.enterprise.execute(SITE_KEY, { action });
            resolve(token);
          } catch (err) {
            reject(err);
          }
        });
      });
    },
  }));

  // v3 is invisible — no UI to render
  return null;
});

Captcha.displayName = 'Captcha';

Captcha.propTypes = {
  rootClassName: string,
  className: string,
};

export default Captcha;
